const formatter = new Intl.NumberFormat("ja-JP");

export const formatPointNumber = (point: number) =>
  point >= 10000 ? formatter.format(point) : point;
